import styles from './LkmAppealDetailService.module.scss'

import { LkmAppealDetailResponse } from 'feature/lkmAppeals/types'
import { FC } from 'react'
import { Button, Rating } from 'ui'

type LkmAppealDetailProps = {
  data: LkmAppealDetailResponse['result']
}
export const LkmAppealDetailService: FC<LkmAppealDetailProps> = ({ data }) => {
  return (
    <div className={styles.appealService}>
      {data.status === 'in_progress' && data.linkFitter && (
        <Button
          // @ts-ignore
          to={data.linkFitter}
          variant='contained'
          color='primary'
          size='small'
          data-testid='lkm-detail-complete-btn'
        >
          Завершить монтаж
        </Button>
      )}

      {data.status === 'in_progress' && !data.linkFitter && (
        <span className='default-text'>Ваш монтаж на проверке</span>
      )}
      {data.status === 'completed' && (
        <div className={styles.appealService__rating}>
          <span className='default-text'>Оценка монтажа:</span>
          <Rating value={data.gradeFitter} readOnly />
        </div>
      )}
    </div>
  )
}
